import { render, staticRenderFns } from "./detailIndexgraduate.vue?vue&type=template&id=3c7db56e&scoped=true"
import script from "./detailIndexgraduate.vue?vue&type=script&lang=js"
export * from "./detailIndexgraduate.vue?vue&type=script&lang=js"
import style0 from "./detailIndexgraduate.vue?vue&type=style&index=0&id=3c7db56e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7db56e",
  null
  
)

export default component.exports